export class UnsetError {
    static readonly type = '[Error] UnsetError';
}
